import React, { useState } from 'react'
import AOS from "aos"; // Import AOS library
import CustomHelmet from '../components/CustomHelmet'
import Banner from '../components/Banner'
import TermsAndConditionsSec from '../sections/termsAndConditions/TermsAndConditionsSec';
import { t } from 'i18next';
import { fetchAPI } from '../helper/fetchAPI';
import * as constants from "../constants";
import { useTranslation } from 'react-i18next';
import { useCountryPrefix } from '../routes/useCountryPrefix';
import FullScreenLoader from '../components/FullScreenLoader';

const TermsAndConditions = () => {

    const { i18n } = useTranslation();
    const countryPrefix = useCountryPrefix();

    const isArabic = i18n.language === "ar";
    const language = isArabic ? "ar" : "en";
    const [isLoaded, setIsLoaded] = useState(false);
    const [pageContent, setPageContent] = useState();

    let apiUrl = process.env.REACT_APP_API_URL;

    apiUrl = `${apiUrl}${constants.staticpages}/terms-conditions?language=${language}&region_id=${countryPrefix}`;

    const fetchData = async () => {
        const res = await fetchAPI(apiUrl, "Get");
        if (res?.status === 200) {

            setPageContent(res?.data?.body)
            setIsLoaded(true)
        }
    }

    React.useEffect(() => {
        AOS.init();
        fetchData()
    }, []);

    if (!isLoaded) {
        return (
            <FullScreenLoader />
        )
    }
    return (
        <>
            <CustomHelmet
                title={"Exclusive Real Estate Across Egypt"}
                desc={'Connect Homes makes exploring real estate in Egypt simple and seamless.'}
            />
            <Banner
                title={t("termsandconditions")}
                desc={t("banner_desc")}
            ></Banner>
            <TermsAndConditionsSec data={pageContent}></TermsAndConditionsSec>
        </>
    )
}

export default TermsAndConditions